import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'
import {getAwsStage} from '@oc/utils'
import {messages} from '../Components/translations'

const UxLab = React.lazy(async () => ({
    default: (await import('@oc/ux-lab/module')).UxLabModule
}))

export function UxLabComponent() {
    if (getAwsStage() === 'dev') {
        return <SuspenseWhileLoading LazyComponent={UxLab} />
    }

    return <>{messages.getText('errors', 'uxLabOnlyAvailableOnDevState')}</>
}
